import { VStack, HStack, Heading, Text, Divider, Link } from '@chakra-ui/react'
import { FaChevronLeft } from 'react-icons/fa6'
import { PageBackLink, PaymentForm } from '@!/User/Payment/components'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'

const RestoreConfirm = ({
  newCardToken,
  currentCard,
  handleSubmit,
  handleChangeCard,
  handlePageBack,
  handleApiErrorPopup,
  handleComplete,
  apiErrorText,
  isApiErrorOpen,
  isComplete,
  isProcessing,
}) => (
  <VStack maxW="600px" m="auto" spacing={0}>
    <HStack w="full" position="relative" py={3} px={4}>
      <Link
        href="/user/monthly_course_histories"
        textDecoration="none"
        color="label.secondary"
        position="absolute"
        left={4}
        top="50%"
        transform="translateY(-50%)"
      >
        <FaChevronLeft fontSize="2xl" />
      </Link>
      <Heading as="h1" size="sm" m="auto">
        月額コース再登録ページ
      </Heading>
    </HStack>
    <Divider />
    <Text fontSize="xs" p={4}>
      更新日より30日以内に当ページから再登録手続き完了で継続ボーナスを引き続き受け取ることができます。
      <br />
      <Text as="span" color="label.accent" fontWeight="semibold">
        カード情報の更新をお願いいたします。
      </Text>
    </Text>
    <Divider />
    <PaymentForm newCardToken={newCardToken} currentCard={currentCard} handleSubmit={handleSubmit} onChangeCard={handleChangeCard} restore />
    <PageBackLink pageBack={handlePageBack} />
    <CircularProgressModal isOpen={isProcessing} />
    <ConfirmPopupModal handlePopup={handleApiErrorPopup} text={apiErrorText} isOpen={isApiErrorOpen} />
    <ConfirmPopupModal handlePopup={handleComplete} text="月額コースの再登録が完了しました。" isOpen={isComplete} />
  </VStack>
)

export default RestoreConfirm
